module.exports = __webpack_public_path__ + "static/media/SWSCRC6-38.2a2c9113.mp3";